<template>
  <div class="bind-tips">
    <div class="bind-tips-header">
      <p>
        <i class="i-user"></i>
        <label class="user-name">{{driverInfo.driver_name}}</label>
      </p>
      <p class="main-tips">{{$t('bindTips.mainTips')}}</p>
    </div>
    <div class="sub-tips">{{$t('bindTips.subTips')}}</div>
    <div class="bottom-area">
      <a @click="handleClick">{{$t('确认')}}</a>
    </div>
  </div>
</template>
<script>
import { get } from "../../tools/request";
import { showToast } from "../../tools/Tip";
import { ends } from "../../tools/constant";
const TOAST_TIME = 5000;
export default {
  computed: {
    routeParams() {
      return this.$route.params || {};
    },
    driverInfo() {
      return this.routeParams.driverInfo || {};
    }
  },
  data() {
    return {
      model: ''
    }
  },
  created() {
    this.getPhoneInfo()
  },
  methods: {
    // 获取手机型号
    getPhoneInfo() {
        if(Fusion && Fusion.getSystemInfo) {
          Fusion.getSystemInfo({},(info) => {
            if(info && info.model) {
              this.model = info.model
            } else {
              this.model = (/(?:Android)/.test(navigator.userAgent) ? 'android': 'iPhone') 
            }
          });
        } else {
          this.model = (/(?:Android)/.test(navigator.userAgent) ? 'android': 'iPhone')
        }
    },
    handleClick() {
      let up = new URLSearchParams(location.search);
      up.set("ticket", up.get("driverLeaderTicket"));
      up.set("did", this.driverInfo.driver_id);
      up.get('lng') ? up.set("lng", up.get("lng")) : up.set("lng", 0)
      up.get('lat') ? up.set("lat", up.get("lat")) : up.set("lat", 0)
      up.set("user_agent", window.navigator.userAgent)
      up.set("model",this.model)
      
      get(process.env.CARS_DRIVER_SEND_BIND_INVITE, {
        params: up
      })
        .then(data => {
          showToast(this,{
            type: "correct",
            txt: this.$t("sendSuccess"),
            time: TOAST_TIME
          });
          setTimeout(() => {
            if (Fusion && Fusion.loadModule) {
              let form_source = up.get('form_source');
              if (form_source == 'fleetApp') {
                const fleetUrl = process.env.FLEET_DRIVER_URL;
                const module = Fusion.loadModule("newPageModule");
                ends.inApp && module.openNewPage({
                  url: fleetUrl,
                  back_to_fleethome: 1,
                  tab_index: 2
                });
                !ends.inApp && location.replace(fleetUrl);
                return;
              }
              const module = Fusion.loadModule("closePageModule");
              module.bridgeMethod && module.bridgeMethod({}, res => {});
            }
          }, TOAST_TIME);
        })
        .catch(e => {
          showToast(this,{
            type: "error",
            txt: e.errmsg || "",
            time: TOAST_TIME
          });
        });
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../css/mixin.scss";
.bind-tips {
  padding: 3rem 0.36rem 0;
  box-sizing: border-box;
  min-height: 100%;
  text-align: center;
  .bind-tips-header {
    position: relative;
    &:after {
      content: "";
      pointer-events: none;
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      transform-origin: 0 0;
      border-bottom: 1px solid #e1e2e6;
      box-sizing: border-box;
      width: 200%;
      height: 200%;
      transform: scale(0.5) translateZ(0);
    }

    margin-bottom: 0.2rem;
    overflow: hidden;
    .i-user {
      display: inline-block;
      width: 0.67rem;
      height: 0.67rem;
      @include bg-img("user");
      background-size: 0.67rem;
      margin-right: 0.16rem;
      vertical-align: middle;
    }
    .user-name {
      vertical-align: middle;
    }
    > p {
      margin-bottom: 0.2rem;
      font-size: 0.36rem;
    }
    .main-tips {
      color: #ff7226;
    }
  }
  .sub-tips {
    color: #949494;
    font-size: 0.28rem;
  }
  .bottom-area {
    position: fixed;
    box-sizing: border-box;
    width: 100%;
    bottom: 0;
    left: 0;
    padding: 0.36rem;
    background: #f5f5f7;
    a {
      display: block;
      width: 6.8rem;
      height: 1.08rem;
      font-size: 0.32rem;
      line-height: 1.08rem;
      text-align: center;
      font-family: "HelveticaNeue-Medium";
      color: #fff;
      background: #ff7226;
      background: linear-gradient(45deg, #ff5b1d, #ff7f41);
      border-radius: 6px;
    }
  }
}
</style>
